import { userStorage } from "../_utils/userStorage.js";
import { apiFetch } from "../_utils/apiInterceptor.js";
import * as validators from "../_utils/validators.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = `${backendUrl}/api/v1/onboarding`;

const validateBusiness = (formData) => {
  if (!formData.businessName || validators.isEmpty(formData.businessName))
    throw new Error("Business name is required");

  if (!formData.productId || validators.isEmpty(formData.productId))
    throw new Error("Product ID is required");

  if (!formData.planId || validators.isEmpty(formData.planId))
    throw new Error("Plan ID is required");

  if (
    validators.isLongerThan(formData.businessName, 100) ||
    validators.isShorterThan(formData.businessName, 5)
  )
    throw new Error("Business name must be between 5 and 100 characters long");

  if (!formData.physicalAddress || validators.isEmpty(formData.physicalAddress))
    throw new Error("Physical address is required");

  if (!formData.city || validators.isEmpty(formData.city))
    throw new Error("City is required");

  if (
    validators.isLongerThan(formData.city, 15) ||
    validators.isShorterThan(formData.city, 4)
  )
    throw new Error("City must be between 4 and 15 characters long");

  if (!formData.emailAddress || !validators.isValidEmail(formData.emailAddress))
    throw new Error("Invalid email format");

  if (!formData.mobileNumber || !validators.isValidMobileNumber(formData.mobileNumber))
    throw new Error("Invalid mobile number format");

}

export const registerWithoutUser = async (formData) => {
  validateBusiness(formData);

  return await apiFetch(
    `${BASE_URL}/new-user`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData),
  });
};  

export const registerWithUser = async (formData) => {
  validateBusiness(formData);

  return await apiFetch(
    `${BASE_URL}/existing-user`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData),
  });
};  
